import { SvgIcon } from "@mui/material";
import { IconProps } from "../_interface";

const TicketValidation = (props: IconProps) => {
  return(
    <SvgIcon {...props} color="inherit" viewBox="0 0 12 13">
     <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 1.5V3.5" stroke="#2E434D" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 9.5V11.5" stroke="#2E434D" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.46509 2.96497L3.88009 4.37996" stroke="#2E434D" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.12 8.62L9.535 10.035" stroke="#2E434D" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1 6.5H3" stroke="#2E434D" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M9 6.5H11" stroke="#2E434D" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M2.46509 10.035L3.88009 8.62" stroke="#2E434D" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.12 4.37996L9.535 2.96497" stroke="#2E434D" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
   </SvgIcon>
  );
}

export default TicketValidation;